export default {
  data () {
    return {
      /**
       * Timeout used to differentiate between a "tap" and a "hold"
       * 
       * Limit set to 200ms
       * @private
       */
      _tapTimeout: undefined,
    }
  },
  methods: {
    /**
     * 
     * @param {Function} callback Function to run on tap-end
     * @param  {...*} args List of arguments to pass into `callback`
     * @returns {Object} Event object compatible with v-touch Directive
     */
    $ftTap (callback, ...args) {
      return {
        start: () => this._tapStart(),
        end: () => this._tapEnd(callback, args)
      }
    },
    /** @private */
    _tapStart () {
      this._tapTimeout = true
      setTimeout(() => this._tapTimeout = false, 200)
    },
    /** @private */
    _tapEnd (callback, args) {
      if (this._tapTimeout) this.runLast(callback, args)
    },
    runLast: (callback, args) => setTimeout(() => callback?.(...args))
  }
}